import CopyMailIcon from 'Components/common/assets/svgIcons/CopyMailIcon';
import DeleteIcon from 'Components/common/assets/svgIcons/DeleteIcon';
import DoubleCheckIcon from 'Components/common/assets/svgIcons/DoubleCheckIcon';
import MoveToFolderSvg from 'Components/common/assets/svgIcons/MoveToFolderSvg';
import { selectCurrentHubView } from 'Selector/DocumentHubSelector';
import { actions } from 'Slice/DocumentHubSlice';
import { IsMobile } from 'Utils/UtilityFunctions';
import {
  greyColor, maxMobile, primaryColor,
  primaryFont, wLight, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { Drawer } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const StyleWrapper = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
.left-side-accordion {
  display: flex;
  align-items: center;
  width: calc(100% - 97px);
  .double-check-icon {
    margin-right: 14px;
    @media all and (max-width: ${maxMobile}) {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
  }
  .selected-text {
    color: ${greyColor};
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 18px;
    margin-right: 8px;
    letter-spacing: -0.633px;
    max-width: calc(100% - 110px);
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
    }
  }
  .clear-text {
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-weight: ${wLight};
    font-size: 12px;
    letter-spacing: -0.3px;
    margin-top: 6px;
    cursor: pointer;
    @media all and (max-width: ${maxMobile}) {
      font-size: 10px;
      margin-top: 3px;
    }
  }
}
.right-side-accordion {
  display: flex;
  align-items: center;
  .delete-button {
    &.primary-button {
      color: #fff;
      background-color: ${primaryColor};
      border: 1px solid ${primaryColor};
      margin-right: 8px;
    }
    display: inline-flex;
    align-items: center;
    column-gap: 5px;
    border-radius: 23px;
    border: 1px solid ${greyColor};
    color: ${greyColor};
    font-family: ${primaryFont};
    font-size: 15px;
    line-height: 12px;
    font-weight: ${wMBold};
    padding: 8px 16px 9px 12px;
    max-height: 36px;
    cursor: pointer;
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      padding: 7px 12px;
      max-height: 30px;
    }
    svg {
      width: 18px;
      height: 18px;
      max-width: 18px;
      margin-right: 4px;
      @media all and (max-width: ${maxMobile}) {
        width: 18px;
        height: 17px;
        margin-bottom: 2px;
        margin-right: 0px;
      }
    }
  }
}
`;

type Props = {
  count?: number,
  drawerVisible: boolean,
  footerForModal?: boolean,
  isDeleteButtonDisabled: boolean,
  handleMultipleDocumentsDelete: () => void,
  clearSelection: () => void,
  isFolderSelected: boolean
} & typeof defaultProps;

const defaultProps = {
  count: 0,
  footerForModal: false,
};

const DocumentBottomAccordion = function DocumentBottomAccordion(props: Props) {
  const {
    count, drawerVisible, isDeleteButtonDisabled, handleMultipleDocumentsDelete,
    clearSelection, footerForModal, isFolderSelected,
  } = props;

  const currentView = useSelector(selectCurrentHubView);

  const text = currentView === 'document' ? 'documents' : currentView === 'folder' ? 'folders' : 'items';

  const dispatch = useDispatch();

  const onCopy = () => {
    dispatch(actions.setFoldersPopupType('copy'));
    dispatch(actions.toggleFoldersPopup(true));
  };

  const onMove = () => {
    dispatch(actions.setFoldersPopupType('move'));
    dispatch(actions.toggleFoldersPopup(true));
  };
  const isMob = IsMobile();
  return (
    <Drawer
      placement="bottom"
      closable
      onClose={() => { }}
      open={drawerVisible}
      height={isMob ? 60 : 87}
      zIndex={3}
      mask={false}
      className={classNames('bottom-accordion-document-hub', { footerForItemFolder: footerForModal })}
      rootClassName="bottom-accordion-document-hub-root"
    >
      <StyleWrapper>
        <div className="left-side-accordion">
          <DoubleCheckIcon />
          <span className="selected-text text-truncate">
            {count}
            {' '}
            {count === 1 ? text.slice(0, -1) : text}
            {' '}
            selected
          </span>
          <span
            role="button"
            tabIndex={0}
            className="clear-text"
            onKeyPress={() => clearSelection()}
            onClick={() => clearSelection()}
          >
            Clear selection
          </span>
        </div>
        <div className="right-side-accordion">
          <span
            role="button"
            tabIndex={0}
            className={classNames('delete-button primary-button', { disabled: isFolderSelected })}
            onKeyPress={onCopy}
            onClick={onCopy}
          >
            <CopyMailIcon color="#fff" />
            {isMob ? '' : 'Copy'}
          </span>
          <span
            role="button"
            tabIndex={0}
            className={classNames('delete-button primary-button', { disabled: isFolderSelected })}
            onKeyPress={onMove}
            onClick={onMove}
          >
            <MoveToFolderSvg color="#fff" />
            {isMob ? '' : 'Move'}
          </span>
          <span
            role="button"
            tabIndex={0}
            className={classNames('delete-button', { disable: isDeleteButtonDisabled })}
            onKeyPress={handleMultipleDocumentsDelete}
            onClick={handleMultipleDocumentsDelete}
          >
            <DeleteIcon color="#7E7E7E" />
            {isMob ? '' : 'Delete'}
          </span>
        </div>
      </StyleWrapper>
    </Drawer>
  );
};
DocumentBottomAccordion.defaultProps = defaultProps;
export default DocumentBottomAccordion;
